import axios from "axios";
import apiURI from "../service/Api";
import { getLocale } from "./locale/locale";

/** Domínio próprio do white label de onde o usuário veio (ex.: https://portale.aisi.it), para o "Voltar". */
const RETURN_KEY = "__extraconomy_federnet_return";

/**
 * Endereço da Federnet no mesmo ambiente da API: a API de teste aponta para test.federnet.it, a de produção para
 * federnet.it. REACT_APP_FEDERNET_URL substitui os dois, se definida.
 */
const getDefaultFedernetUrl = () => {
  if (process.env.REACT_APP_FEDERNET_URL) return process.env.REACT_APP_FEDERNET_URL.replace(/\/$/, "");
  const api = process.env.REACT_APP_API_TEST || "";
  return /apitest|localhost/.test(api) ? "https://test.federnet.it" : "https://federnet.it";
};

const getFedernetUrl = () => {
  try {
    return localStorage.getItem(RETURN_KEY) || getDefaultFedernetUrl();
  } catch {
    return getDefaultFedernetUrl();
  }
};

/**
 * Chamado na entrada vinda da Federnet (FedernetHandoff). `back` só vem quando o usuário estava no domínio próprio de
 * um WL. Só guardamos depois de a API confirmar que o domínio é de um WL (senão qualquer site poderia virar o destino
 * do "Voltar"). Sem `back` ou inválido: volta para a Federnet padrão.
 */
export const rememberFedernetReturn = async (back) => {
  try {
    localStorage.removeItem(RETURN_KEY);
    if (!back) return;
    const url = new URL(back);
    if (url.protocol !== "https:") return;
    const host = url.host.toLowerCase();
    const res = await axios.get(`${apiURI}/federnet/public/domains/${encodeURIComponent(host)}`);
    if (res.data?.result?.username) localStorage.setItem(RETURN_KEY, `https://${host}`);
  } catch (e) {
    console.error("Federnet return address ignored:", e);
  }
};

/** Painel da Federnet no idioma atual. Sem sessão lá, a própria Federnet manda para o login do white label. */
export const getFedernetDashboardUrl = () => `${getFedernetUrl()}/${getLocale()}/dashboard`;
